import React, { useState, useEffect } from 'react'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import BtnEditAll from '../../../components/buttons/btnEditAll/BtnEditAll'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getIsEditAll, setIsEditAll, handleOnChangeIsEdit } from '../../../utils/widget'
import { ERR_MSG_404_PROJECT_ID } from '../../../constants/msgText'
import SubProjectGoalTenYear from '../../../widgets/goalTenYear/SubProjectGoalTenYear'
import { SUB_PROJECT_ID, TEMP_FORM_ID } from '../../../constants/constants'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import ContentHeaderWidget from '../../../components/ContentHeader/ContentHeaderWidget'
import { getSubProjectProjectGoal } from '../../../redux/actions/subProjectProposal'

export default function SubProjectProposalGoal() {
  const [isEditWidget, setIsEditWidget] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()

  const [showEditAll, setShowEditAll] = useState()

  const mode = location.search.substring(1)
  const subProjectId = sessionGetItemStr(SUB_PROJECT_ID)
  const formId = sessionGetItemStr(TEMP_FORM_ID)

  useEffect(() => {
    if (subProjectId) {
      handleGetSchema()
    } else {
      setError({
        statusCode: 404,
        errorMessage: ERR_MSG_404_PROJECT_ID,
      })
    }
    //projectId && handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSubProjectProjectGoal(subProjectId)
      // const _schema = mockSchema
      setSchema(_schema)
      setIsEditWidget({
        goalTenYear:
          _schema.forms.goalTenYear.optionSelected.length > 0 ||
          _schema.forms.goalTenYear?.inputOther?.value
            ? false
            : true,
      })

      setShowEditAll(!_schema.forms?.goalTenYear?.disabled)
    } catch (e) {
      console.log('e : ', e)
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isNewSubProject>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isNewSubProject>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal isNewSubProject>
        <ContentHeaderWidget header={schema.header} subHeader={schema.subHeader} />

        {/* <MainProjectInfo schema={schema?.info?.projectInfo} /> */}

        {showEditAll && (
          <>
            <BtnEditAll
              onClickEditAll={getIsEditAll(isEditWidget)}
              routing={schema.buttonRoute}
              setOnClickEditAll={(_isEdit) => setIsEditAll(_isEdit, isEditWidget, setIsEditWidget)}
              editWidget={isEditWidget}
              forms={schema?.forms}
            />
          </>
        )}

        {schema?.forms?.goalTenYear && (
          <>
            <SubProjectGoalTenYear
              showCommandButton={!schema.forms.goalTenYear.disabled}
              schema={schema.forms.goalTenYear}
              isEdit={isEditWidget.goalTenYear}
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit('goalTenYear', _isEdit, setIsEditWidget)
              }
            />
            <br />
          </>
        )}
      </SidebarProposal>
    </>
  )
}
